import * as React from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import {
  Button,
  DateTextBox,
  FlexLayout,
  GridLayout,
  IFrame,
  ModalView,
  SearchLayout,
  SubHeader,
  TextBox,
} from '../../../../components';
import { Global, TemplateProps } from '../../../../constants';
import { Status } from './Status';
import { StatusGridHeader } from './headers/StatusGridHeader';
import { StatusDetailGridHeader } from './headers/StatusDetailGridHeader';
import { SearchBinding } from '../../../../models';

/**
 * 화면
 * @window w_tb_e101w_05
 * @category 월별 관리대수변동내역
 */
export const StatusTemplate: React.FC<TemplateProps<Status>> = ({
  scope,
}) => (
    <FlexLayout isVertical={true}>
      <SearchLayout size={Global.LAYOUT_SEARCH_HEIGHT_1}>
        <FlexLayout size={200}>
          <span>년도</span>
          <DateTextBox
            value={scope.state.year}
            textAlign="center"
            format="####"
            onChange={(value) => scope.SS({ year: value })}
            onEnter={(value) => scope.setState({ year: value }, () => scope.onRetrieveEvent())}
            head={(
              <button
                onClick={() => {
                  const date = new Date(`${scope.state.year}-01-01`);
                  date.setFullYear(date.getFullYear() - 1);
                  scope.setState({ year: date.getFullYear().toString() },
                    () => scope.onRetrieveEvent());
                }}
              >
                <MdKeyboardArrowLeft size={24}/>
              </button>
            )}
            trail={(
              <button
                onClick={() => {
                  const date = new Date(`${scope.state.year}-01-01`);
                  date.setFullYear(date.getFullYear() + 1);
                  scope.setState({ year: date.getFullYear().toString() },
                    () => scope.onRetrieveEvent());
                }}
              >
                <MdKeyboardArrowRight size={24}/>
              </button>
            )}
            isDisabledTrackingStateChange={true}
          elField="year"
          />
        </FlexLayout>

        <FlexLayout size={268} style={{ marginLeft: 32 }}>
          <span style={{ color: 'var(--color-red)', marginRight: 20 }}>부서</span>
          <TextBox
            textAlign="center"
            value={scope.state.divicd}
            onChange={(value) => scope.SS({ divicd: value })}
            noPadding={true}
            bindSearchModal={new SearchBinding(
              scope.props.modalStore,
              'TB_JC002',
              {},
              true,
              (item) => {
                scope.SS({
                  divicd: item.cd,
                  divinm: item.cdnm,
                });
                scope.onRetrieveEvent();
              },
            )}
            isDisabledTrackingStateChange={true}
          elField="divicd"
          />
          <TextBox
            weight={1.2}
            value={scope.state.divinm}
            readonly={true}
            onChange={(value) => scope.SS({ divinm: value })}
          elField="divinm"
          />
        </FlexLayout>

        <FlexLayout size={268}>
          <span style={{ color: 'var(--color-red)' }}>사원명</span>
          <TextBox
            value={scope.state.perid}
            textAlign="center"
            onChange={(value) => scope.SS({ perid: value })}
            bindSearchModal={new SearchBinding(
              scope.props.modalStore,
              'TB_JA001',
              {},
              true,
              (item) => {
                scope.SS({
                  perid: item.cd,
                  pernm: item.cdnm,
                });
                scope.onRetrieveEvent();
              },
            )}
          elField="perid"
          />
          <TextBox
            weight={1.2}
            value={scope.state.pernm}
            textAlign="center"
            onChange={(value) => scope.SS({ pernm: value })}
            readonly={true}
          elField="pernm"
          />
        </FlexLayout>

        <FlexLayout
          size={300}
          align="center"
          justify="start"
          style={{
            paddingLeft: 12,
            fontSize: 13,
          }}
        >
          {scope.state.bemon12}
        </FlexLayout>
      </SearchLayout>

      <FlexLayout isVertical={true}>
        <FlexLayout>
          <GridLayout
            ref={scope.grid}
            header={StatusGridHeader(scope)}
            rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
            data={scope.state.data}
            infinityHandler={scope.infinity}
          elGrid="data"
          />
        </FlexLayout>

        <FlexLayout>
          <IFrame src={scope.state.graph} />
        </FlexLayout>
      </FlexLayout>


      {/* 상세 */}
      <ModalView
        isVisible={scope.state.isVisibleModal}
        width={1600}
        height={1000}
        onClose={() => scope.SS({ isVisibleModal: false })}
      >
        <FlexLayout
          isVertical={true}
          style={{
            padding: 8,
          }}
        >
          <FlexLayout>
            <FlexLayout isVertical={true}>
              <FlexLayout>
                <FlexLayout isVertical={true}>
                  <SubHeader>
                    <span style={{ color: 'var(--color-green)' }}>* 만료</span>
                  </SubHeader>

                  <GridLayout
                    header={StatusDetailGridHeader(scope, 0)}
                    data={scope.state.dataModalExpire}
                    rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
                  elGrid="dataModalExpire"
                  />
                </FlexLayout>

                <FlexLayout isVertical={true}>
                  <SubHeader>
                    <span style={{ color: 'var(--color-violet)' }}>* 무상</span>
                  </SubHeader>

                  <GridLayout
                    header={StatusDetailGridHeader(scope, 1)}
                    data={scope.state.dataModalFree}
                    rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
                  elGrid="dataModalFree"
                  />
                </FlexLayout>
              </FlexLayout>

              <FlexLayout>
                <FlexLayout isVertical={true}>
                  <SubHeader>
                    <span style={{ color: 'var(--color-blue)' }}>* 신규</span>
                  </SubHeader>

                  <GridLayout
                    header={StatusDetailGridHeader(scope, 2)}
                    data={scope.state.dataModalNew}
                    rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
                  elGrid="dataModalNew"
                  />
                </FlexLayout>

                <FlexLayout isVertical={true}>
                  <SubHeader>
                    <span style={{ color: 'var(--color-red)' }}>* 해지</span>
                  </SubHeader>

                  <GridLayout
                    header={StatusDetailGridHeader(scope, 3)}
                    data={scope.state.dataModalCancel}
                    rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
                  elGrid="dataModalCancel"
                  />
                </FlexLayout>
              </FlexLayout>
            </FlexLayout>
          </FlexLayout>

          <FlexLayout size={Global.LAYOUT_BUTTON_HEIGHT_1}>
            <Button
              isFull={true}
              onClick={() => scope.SS({ isVisibleModal: false })}
            >
              닫기
            </Button>
          </FlexLayout>
        </FlexLayout>
      </ModalView>
    </FlexLayout>
);
